import { wsService } from "./wsService";

const section = "webhooks";

const EVENT_TYPE_CIERRE_ASN = "CierreASN";
const EVENT_TYPE_EXPEDIR_PEDIDO = "ExpedirPedido";
const EVENT_TYPE_AJUSTE_STOCK = "AjusteStock";
const EVENT_TYPE_CAMBIO_ATRIBUTO = "CambioAtributo";
const EVENT_TYPE_CREACION_PEDIDO = "CreacionPedido";
const EVENT_TYPE_CANCELACION_PEDIDO = "CancelacionPedido";
const EVENT_TYPE_ELIMINACION_PEDIDO = "EliminacionPedido";

const EVENT_TYPE_NAMES = {
  [EVENT_TYPE_CIERRE_ASN]: "Cierre de ASN",
  [EVENT_TYPE_EXPEDIR_PEDIDO]: "Expedición de Pedido",
  [EVENT_TYPE_AJUSTE_STOCK]: "Ajuste de Stock",
  [EVENT_TYPE_CAMBIO_ATRIBUTO]: "Cambio de Atributo",
  [EVENT_TYPE_CREACION_PEDIDO]: "Creación de Pedido",
  [EVENT_TYPE_CANCELACION_PEDIDO]: "Cancelación de Pedido",
  [EVENT_TYPE_ELIMINACION_PEDIDO]: "Eliminación de Pedido",
};

// Cantidad máxima de intentos de envío (Webhook::MAX_ATTEMPTS en el backend)
const MAX_ATTEMPTS = 5;

const STATE_DELIVERED = "delivered";
const STATE_PENDING = "pending";
const STATE_FAILED = "failed";
const STATE_NOT_SUBSCRIBED = "not_subscribed";

const STATE_NAMES = {
  [STATE_DELIVERED]: "Enviado",
  [STATE_PENDING]: "Pendiente",
  [STATE_FAILED]: "Fallido",
  [STATE_NOT_SUBSCRIBED]: "No suscripto",
};

const STATE_OPTIONS = [
  { id: STATE_DELIVERED, name: STATE_NAMES[STATE_DELIVERED] },
  { id: STATE_PENDING, name: STATE_NAMES[STATE_PENDING] },
  { id: STATE_FAILED, name: STATE_NAMES[STATE_FAILED] },
  { id: STATE_NOT_SUBSCRIBED, name: STATE_NAMES[STATE_NOT_SUBSCRIBED] },
];

function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function list_event_types() {
  return wsService.make_get_request(section + "/list_event_types");
}

function resend(id) {
  return wsService.make_post_request(section + "/resend", { id: id });
}

function reset(id) {
  return wsService.make_post_request(section + "/reset", { id: id });
}

function getEventTypeName(event_type) {
  return EVENT_TYPE_NAMES[event_type] || event_type;
}

function getState(item) {
  if (item.delivered_date) return STATE_DELIVERED;
  // No suscripto: el cliente no estaba suscripto al evento, no se envia
  if (item.not_subscribed) return STATE_NOT_SUBSCRIBED;
  // Fallido: se intento enviar al menos una vez. Pendiente: nunca se intento.
  if (item.attempts >= 1) return STATE_FAILED;
  return STATE_PENDING;
}

function getStateName(item) {
  return STATE_NAMES[getState(item)];
}

export const webhookService = {
  section,
  EVENT_TYPE_CIERRE_ASN,
  EVENT_TYPE_EXPEDIR_PEDIDO,
  EVENT_TYPE_AJUSTE_STOCK,
  EVENT_TYPE_CAMBIO_ATRIBUTO,
  EVENT_TYPE_CREACION_PEDIDO,
  EVENT_TYPE_CANCELACION_PEDIDO,
  EVENT_TYPE_ELIMINACION_PEDIDO,
  EVENT_TYPE_NAMES,
  MAX_ATTEMPTS,
  STATE_DELIVERED,
  STATE_PENDING,
  STATE_FAILED,
  STATE_NOT_SUBSCRIBED,
  STATE_NAMES,
  STATE_OPTIONS,
  filter,
  list_event_types,
  resend,
  reset,
  getEventTypeName,
  getState,
  getStateName,
};
